import { render, staticRenderFns } from "./BranchInformation.vue?vue&type=template&id=55337167&scoped=true&"
import script from "./BranchInformation.vue?vue&type=script&lang=js&"
export * from "./BranchInformation.vue?vue&type=script&lang=js&"
import style0 from "./BranchInformation.vue?vue&type=style&index=0&id=55337167&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55337167",
  null
  
)

export default component.exports